
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CertificateInterface, CertificatesRepositoryInterface } from '../../../services/SSL/interfaces';

@Component({
  inject: [
    'certificateRepository',
  ],
})
export default class DeleteCertificateDialog extends Vue {
  private visible: boolean = true;
  private certificateRepository!: CertificatesRepositoryInterface;
  @Prop() private readonly certificate!: CertificateInterface;

  get message(): string {
    return `Are you sure you want to delete certificate for domain ${this.certificate.domain}?`;
  }

  private destroyComponent(): void {
    this.$emit('close');
  }

  private async deleteCertificate(): Promise<void> {
    try {
      await this.certificateRepository.deleteCertificate(this.certificate.websiteId);
      this.$successDialog.show(`Certificate for ${this.certificate.domain} has been deleted!`);
      this.$emit('deleted-certificate');
      this.destroyComponent();
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }
}
